<template>
  <div class="bg-black text-center py-5 text-white text-xs">
    <div>
      © 2024 Open Terzo Settore - P.IVA: 09473230960
    </div>
    <div>
      Capitale sociale 10.600€ – Numero REA MI - 2092647
    </div>
    <div>
      <a target="_blank" href="https://italianonprofit.it/termini-e-condizioni-duso/" class="underline">Condizioni generali di utilizzo</a> |
      <a target="_blank" href="https://italianonprofit.it/privacy/" class="underline">Informativa sulla privacy</a> |
      <a target="_blank" href="https://italianonprofit.it/cookie-policy/" class="underline">Cookie</a>
    </div>

  </div>
</template>